import { Component, Input, EventEmitter, Output } from "@angular/core";
import { GraphicsInfoPositionField } from "../../../../domain/graphics-info";

@Component({
  selector: "icn-graphics-position",
  templateUrl: "./position.component.html",
  styleUrls: ["./position.component.scss"],
})
export class GraphicsPositionComponent {
  valueOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  @Input() positionField: GraphicsInfoPositionField;
  onChangePosition(value: number) {
    this.positionField.value = value;
  }
}
